import { PurchasePersistenceModel } from '../../../core/domain/purchase-persistence/models/PurchasePersistence.model';

export const saveReducer = (
    purchasePersistence: PurchasePersistenceModel,
    { value }: { value: PurchasePersistenceModel },
): PurchasePersistenceModel => value;
